import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Instagram, LogOut, LayoutDashboard } from "lucide-react";

export default function Navbar({ isAdmin, setIsAdmin }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    setIsAdmin(false);
    navigate("/");
  };

  return (
    <nav className="navbar">
      <style>
        {`
          .navbar {
            padding: 1rem 5%;
            border-bottom: 1px solid #1B2318;
            background-color: #080B07;
            position: sticky;
            top: 0;
            z-index: 50;
          }

          .nav-inner {
            width: 100%;
            min-height: 58px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            position: relative;
          }

          .nav-brand-center {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            line-height: 1.1;
          }

          .nav-logo {
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .nav-logo-text {
            color: #A3FF12;
            font-size: 1.5rem;
            font-weight: 900;
            text-shadow: 0 0 10px rgba(163,255,12,0.3);
          }

          .nav-logo-text span {
            color: #fff;
          }

          .nav-ig-help {
            margin-top: 0.35rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.35rem;
            color: #8E9A88;
            text-decoration: none;
            font-size: 0.72rem;
            font-weight: 700;
            white-space: nowrap;
          }

          .nav-ig-help strong {
            color: #A3FF12;
          }

          .nav-ig-help:hover {
            color: #A3FF12;
          }

          .nav-actions {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            flex-wrap: wrap;
          }

          .nav-btn {
            display: inline-flex;
            align-items: center;
            gap: 0.45rem;
            background-color: #11160F;
            border: 1px solid #1B2318;
            padding: 0.55rem 0.85rem;
            border-radius: 999px;
            cursor: pointer;
            font-weight: 800;
            font-size: 0.82rem;
          }

          @media (max-width: 640px) {
            .navbar {
              padding: 0.9rem 1rem;
            }

            .nav-inner {
              min-height: auto;
              justify-content: center;
              flex-direction: column;
              gap: 0.85rem;
            }

            .nav-brand-center {
              position: static;
              transform: none;
            }

            .nav-logo-text {
              font-size: 1.45rem;
            }

            .nav-ig-help {
              font-size: 0.68rem;
              white-space: normal;
              line-height: 1.35;
            }

            .nav-actions {
              justify-content: center;
              width: 100%;
            }
          }
        `}
      </style>

      <div className="nav-inner">
        <div className="nav-brand-center">
          <Link to="/" className="nav-logo">
            <span className="font-display nav-logo-text">
              PARLAY<span>GG</span>
            </span>
          </Link>

          <a
            className="nav-ig-help"
            href="https://www.instagram.com/parlay.gg/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={13} />
            For any questions, message <strong>@parlay.gg</strong> on IG
          </a>
        </div>
      </div>
    </nav>
  );
}